import Category from "@/components/Category/page";
import Banner from "@/components/Banner/page";
import BrandExplore from '@/components/BrandExplore/page';
import BestSeller from '@/components/BestSeller/page';
import BrandCategories from '@/components/BrandCategories/page';
import SolarCard from "@/components/solarCards/page";
import Testimonials from "@/components/testimonials/page";
import Facility from '@/components/Faclities/page'

export default function Home(){
    return(
        <div className="py-0">
            <Category/>
            <Banner/>
            <BrandExplore/>
            <BestSeller/>
            <Facility/>
            <SolarCard/>
            <BrandCategories/>
            <Testimonials/>
            {/* <OtherCards/> */}
        </div>
    )
}